import React from "react";

export default function About({ details }) {
  return (
    <div className="bg-neutral-100">
      <div className="flex flex-col mt-8 bg-white px-4 py-8 rounded-lg">
        <span className="text-xl mb-2">About</span>
        <div
          dangerouslySetInnerHTML={{
            __html: details.about,
          }}
          className="prose max-w-none"
        />
      </div>
    </div>
  );
}
